module.exports = __webpack_public_path__ + "img/sensor-disconnected.a00cfaac.png";